import { ApiContext } from "./api-context";
import { ApiProviderBuilder } from "./builder";

// Build api provider for console api
export const ApiProvider = ApiProviderBuilder({ url: process.env.NX_CONSOLE_API_URL }, ApiContext);
